import { useFormData } from "../../../Hooks/useFormDataContext";
import { useNavigate, useParams } from "react-router-dom";
import axios from "../../../api/axios";
import { useSnackbar } from "notistack";

export default function UserAdminProfileSave(props) {
    const { formData, resetForm } = useFormData();
    const { enqueueSnackbar } = useSnackbar();
    const navigate = useNavigate();
    const params = useParams();

    const user = props.User;

    // Prefer the loaded user; fall back to the route param.
    const userId = Number(user?.UserID ?? params.userid);

    const isEmpty = (obj) =>
        !obj || Object.keys(obj).length === 0;

    const handleCancel = async () => {
        navigate(`/admin/users`);
    }

    const handleSave = async () => {
        if (!Number.isInteger(userId) || userId <= 0) {
            console.error("Save aborted: no valid UserID", {
                propUser: user,
                routeParam: params.userid,
            });
            enqueueSnackbar(
                "Unable to determine which user to save.",
                { variant: "error" }
            );
            return;
        }

        const { User, UserSettings } = formData;

        const userEmpty =
            !User ||
            Object.keys(User).filter(
                key => key !== "UserID"
            ).length === 0;

        const userSettingsEmpty =
            isEmpty(UserSettings);

        try {
            if (userEmpty && userSettingsEmpty) {
                enqueueSnackbar(
                    "Nothing to save.",
                    { variant: "info" }
                );
                return;
            }

            if (!userEmpty && userSettingsEmpty) {
                await axios.put(
                    `/api/users/${userId}`,
                    User
                );
            }
            else if (userEmpty && !userSettingsEmpty) {
                await axios.put(
                    `/api/users/usersettings/${userId}`,
                    UserSettings
                );
            }
            else {
                await axios.put(
                    "/api/users/alluserinfo",
                    {
                        // Make sure the server can identify the user even if
                        // formData.User only holds the changed fields.
                        user: { ...User, UserID: userId },
                        userSettings: UserSettings,
                    }
                );
            }

            enqueueSnackbar(
                "Profile saved successfully.",
                { variant: "success" }
            );

            resetForm();
        }
        catch (ex) {
            console.error(ex);

            enqueueSnackbar(
                ex.response?.data?.error ||
                ex.message ||
                "Failed to save profile.",
                {
                    variant: "error",
                }
            );
        }
    };

   return (
    <div
    className="full-row light-blue"
    style={{
        position: "sticky",
        top: 0,
        zIndex: 1000,
        boxShadow: "0 2px 8px rgba(0,0,0,.15)",
    }}
>
    <div className="container-fluid">
        <div className="row align-items-center py-3">
            <div className="col-md-6 text-white">
                <h1 className="text-uppercase mb-0">
                    {user?.FirstName} {user?.LastName} Profile
                </h1>
                <p className="mb-0 text-white">
                   Manage User Profile
                </p>
            </div>

            <div className="col-md-6 d-flex justify-content-end">
                <a
                    className="button-default button-green me-2"
                    onClick={handleSave}
                    role="button"
                    style={{
                        minWidth: "140px",
                        cursor: "pointer",
                    }}
                >
                    Save Profile
                </a>

                <a
                    className="button-default button-gray"
                    onClick={handleCancel}
                    role="button"
                    style={{
                        minWidth: "140px",
                        cursor: "pointer",
                    }}
                >
                    Cancel
                </a>
            </div>
        </div>
    </div>
</div>
);
}